// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1_K4SXCT","App":"_2LN9JIRp"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/WebApp.styl
// module id = 368
// module chunks = 0